import { effects } from 'redux-saga'

import callWithHmac from '../effects/callWithHmac'
import { begin, end } from '../../modules/loading'
import { receiveProducts } from '../../modules/product'

export default function* load({ invocation }) {
  try {
    yield effects.put.resolve(begin('products'))

    const results = yield effects.call(callWithHmac, invocation.getProducts)

    yield effects.put.resolve(receiveProducts(results.bandwidth_packs, results.products))
  } finally {
    yield effects.put.resolve(end('products'))
  }
}



// WEBPACK FOOTER //
// ./deps/internal-components/src/redux/sagas/product/load.js